export default "__VITE_ASSET__qsoz9mxq__"